<template>
    <SettingsLayout>
        <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink
                class="mr-3"
                href="/einstellungen/nutzerverwaltung"
                type="close"
                >Zurück</HeaderLink
            >
            <HeaderButton :disabled="form.processing" @click="submitForm()"
                >Senden</HeaderButton
            >
        </template>
        <Heading title="Neuen Nutzer einladen" />

        <p class="max-w-2xl text-sm text-oteoText">
            Geben Sie hier bitte die Daten Ihres Mitarbeiters an und versenden
            Sie über Klick auf den Button "Senden" eine E-Mail-Benachrichtigung.
            <br /><br />
            Über den Button „Account erstellen“ in der E-Mail-Einladung kann
            sich der/die neue Nutzer/in bei oteo registrieren und sich dabei
            eigene Anmeldedaten vergeben. Ihr Mitarbeiter kann nun mit oteo
            arbeiten.
        </p>

        <div class="mt-8 mb-6 text-white font-bold flex items-center">
            <Label class="!mb-0" value="Anrede" />
            <input
                v-model="form.salutation"
                class="ml-4 appearance-none"
                id="s_female"
                type="radio"
                value="f"
            />
            <Label
                class="inline ml-2 !mb-0 font-normal"
                for="s_female"
                value="Frau"
            />

            <input
                v-model="form.salutation"
                class="ml-4"
                id="s_male"
                type="radio"
                value="m"
            />
            <Label
                class="inline ml-2 !mb-0 font-normal"
                for="s_male"
                value="Herr"
            />

            <input
                v-model="form.salutation"
                class="ml-4"
                id="s_none"
                type="radio"
                value="n"
            />
            <Label
                class="inline ml-2 !mb-0 font-normal"
                for="s_none"
                value="Keine Angabe"
            />
        </div>

        <div class="grid grid-cols-2 gap-5 max-w-3xl">
            <div class="">
                <Label for="firstname" value="Vorname" />
                <Input
                    id="firstname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.firstname"
                    required
                    autofocus
                    placeholder="Bitte eingeben"
                    autocomplete="given-name"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.firstname">
                    {{ errors.firstname }}
                </div>
            </div>

            <div class="">
                <Label for="lastname" value="Nachname" />
                <Input
                    id="lastname"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.lastname"
                    required
                    placeholder="Bitte eingeben"
                    autocomplete="family-name"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.lastname">
                    {{ errors.lastname }}
                </div>
            </div>

            <div class="">
                <Label for="email" value="E-Mail" />
                <Input
                    id="email"
                    type="email"
                    class="mt-1 block w-full"
                    v-model="form.email"
                    required
                    autocomplete="email"
                    placeholder="Bitte eingeben"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.email">
                    {{ errors.email }}
                </div>
            </div>

            <div class="">
                <Label for="role_id" value="Rolle" />
                <Select class="w-full" v-model="form.role_id">
                    <option disabled value="">Bitte wählen</option>

                    <option
                        v-for="role in roles"
                        :key="role.id"
                        :value="role.id"
                    >
                        {{ `${role.name}` }}
                    </option>
                </Select>

                <div class="mt-2 text-red-600 text-sm" v-if="errors.role_id">
                    {{ errors.role_id }}
                </div>
            </div>
        </div>
    </SettingsLayout>
</template>

<script setup>
const page_name = "Nutzerverwaltung";

const props = defineProps({
    errors: Object,
    roles: Array,
});

function submitForm() {
    saveBtnClicked = true;
    form.post("/users");
}
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

const form = useForm({
    firstname: "",
    lastname: "",
    email: "",
    role_id: "",
    salutation: "f",
});

import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { onUnmounted } from "vue";
</script>
